/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Render_All_Fit_ConfirmInputs */



/**
* | output |
* | --- |
* | "Fit to Event duration" |
*
* @param {Render_All_Fit_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_all_fit_confirm = /** @type {((inputs?: Render_All_Fit_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_All_Fit_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster à la durée")
	if (locale === "de") return /** @type {LocalizedString} */ ("An Event-Dauer anpassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Adatta alla durata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подогнать под длительность")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar a la duración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("适配事件时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの長さに合わせる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट अवधि में फिट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar à duração")
	return /** @type {LocalizedString} */ ("Fit to Event duration")
});